var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextValignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7273 19.5H26.2727C27.2248 19.5 28 18.939 28 18.25C28 17.561 27.2248 17 26.2727 17H10.7273C9.77523 17 9 17.561 9 18.25C9 18.939 9.77523 19.5 10.7273 19.5Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4295 26.0199C21.1128 26.2891 20.6378 26.2891 20.3212 26.0199L18.8962 24.8087V33.2083C18.8962 33.6121 18.5795 34 18.1045 34C17.6295 34 17.3128 33.6121 17.3128 33.2083V24.8087L15.8878 26.0199C15.5712 26.2891 15.0962 26.2891 14.7795 26.0199C14.4628 25.7507 14.4628 25.347 14.7795 25.0778L17.5503 22.7226C17.7087 22.588 17.9462 22.5207 18.1045 22.5207C18.2628 22.5207 18.5003 22.588 18.6587 22.7226L21.4295 25.0778C21.7462 25.347 21.7462 25.818 21.4295 26.0199Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4295 10.9801C21.1128 10.7109 20.6378 10.7109 20.3212 10.9801L18.8962 12.1913V3.79168C18.8962 3.38793 18.5795 3 18.1045 3C17.6295 3 17.3128 3.38792 17.3128 3.79167V12.1913L15.8878 10.9801C15.5712 10.7109 15.0962 10.7109 14.7795 10.9801C14.4628 11.2493 14.4628 11.653 14.7795 11.9222L17.5503 14.2774C17.7087 14.412 17.9462 14.4793 18.1045 14.4793C18.2628 14.4793 18.5003 14.412 18.6587 14.2774L21.4295 11.9222C21.7462 11.653 21.7462 11.182 21.4295 10.9801Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextValignCenter);
export default __webpack_public_path__ + "static/media/text_valign_center.ba769c757344bbc95939f0c96642e6e0.svg";
export { ForwardRef as ReactComponent };